import {atom} from "recoil";
import keys from "configs/atoms";
import {JOIN_STEP} from "configs/page";

const regStepAtom = atom(({
    key: keys.Account.RegStep,
    default: JOIN_STEP.CREATE_ACCOUNT 
}));

export default regStepAtom;